export const wifiOff='wifiOff';